import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

export default function (ComposedComponent) {
  class RequireActiveSubscription extends Component {
    static contextTypes = {
      router: PropTypes.object,
    };

    redirect(to) {
      global.window && window.location && window.location.replace(to + window.location.search);
    }

    render() {
      if (this.props.isLoading) {
        return <div></div>;
      }

      if (this.props.user && this.props.user.status === 'trial') {
        this.redirect('/subscribe');
        return null;
      }

      return <ComposedComponent {...this.props} />;
    }
  }

  function mapStateToProps(state) {
    return {
      isLoading: state.auth.isLoading,
      user: state.auth.user,
    };
  }

  return connect(mapStateToProps)(RequireActiveSubscription);
}
